import { getElementDeserializer, setDefaults } from '@udecode/slate-plugins';
import paragraphElement from './element';

const deserializeParagraph = options => {
  const { p } = setDefaults(options, paragraphElement);

  return {
    element: getElementDeserializer({
      type: p.type,
      rules: [{ nodeNames: 'P' }],
    }),
  };
};

export default deserializeParagraph;
